import styled, {css} from 'styled-components';
import Icon from '../Icon/Icon';
import {device} from '@/styles/template';

export const StyledExitIcon = styled(Icon)<{ testing?: boolean }>`
        height: 7rem;
        width: 7rem;
        
        ${({ testing, theme }) => testing && css`
        & .themedIcon {
            fill: ${theme.color.Overlay};
        }
    `}

        @media ${device.mobileL} {
        ${({ size }) => size && css`
                & {
                        height: ${size}rem;
                        width: ${size}rem;
                }
        `}
}
`;


export const ExitButton = styled.div`
    cursor: pointer;
`